import { Component, OnInit, OnDestroy, AfterContentChecked, AfterViewInit } from '@angular/core';
import { applyFroalaAriaFix, stripFroalaWatermark } from '../../../../common/utils/froala.utils';
import { FormGroup, FormControl } from '@angular/forms';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { ChiefsOrderService } from '../../../../services/chiefsOrder.service';
import { LoaderService } from '../../../../common/services/loader.service';
import { SubHeaderService } from '../../../../core/services/sub-header.service';
import { TextTemplatesService } from '../../../../text-templates/text-templates.service';

import { lettercontentmodel } from '../../../../models/comodel/lettercontentmodel.model';
import { levelContext } from '../../../../models/comodel/chiefsorderdetailsmodel.model';
import { mergeFieldsOrgInfo } from '../../../../common/models/organization.model';
import { SubHeader } from '../../../../core/models/sub-header.model';
import { Group } from '../../../models/group.model';
import { GroupService } from '../../../services/group.service';
import { Dialog, DialogButton } from '../../../../core/models/dialog.model';
import { DynamicDialogService } from '../../../../core/services/dynamic-dialog.service';

@Component({
    selector: 'co-approve-letter',
    templateUrl: './co-approve-letter.component.html',
    styleUrls: ['./co-approve-letter.component.scss'],
    standalone: false
})
export class CoApproveLetterComponent implements OnInit, OnDestroy, AfterViewInit {

    form: FormGroup = new FormGroup({
        updatedContents: new FormControl('')
    });

    private _froalaOptions: any = null;
    get froalaOptions() : any {
        if (!this._froalaOptions) {
            let conf = window["PdfConfig"] as any;
            let key = (conf != null) ? conf.editorLicenseKey : "";
            this._froalaOptions = applyFroalaAriaFix({
                heightMax: 600,
                height: 600,
                heightMin: 150,
                key: key,
                fontSize: ['8', '9', '10', '11', '12', '14', '16', '18', '20', '22', '24', '26', '26.5', '27', '30', '60', '72', '96'],
                fontFamily: {
                    'Arial,Helvetica,sans-serif': 'Arial',
                    'Georgia,serif': 'Georgia',
                    'Impact,Charcoal,sans-serif': 'Impact',
                    'Tahoma,Geneva,sans-serif': 'Tahoma',
                    "'Times New Roman',Times,serif": 'Times New Roman',
                    'Verdana,Geneva,sans-serif': 'Verdana',
                    'Gabriola,sans-serif': 'Gabriola'
                },
                toolbarButtons: ["fullscreen", "html", "|", "undo", "redo", "|", "bold", "italic", "underline", 'strikeThrough', "|", "formatOL", "formatUL", "|", "align", "fontFamily", "fontSize", "paragraphFormat", "insertLink", "|", "outdent", "indent", "clearFormatting", "insertTable", "color"]
            });
        }
        return this._froalaOptions;
    };

    letterContentModel = <lettercontentmodel>{
        htmlContent: 'Type text here',
        id: ''
    };
    titleText: string = "";
    subHeader: SubHeader = new SubHeader({ title: this.titleText });
    id: string;
    coinstanceId: string;
    sub: Subscription[] = [];
    applicationNumber: string;

    orgObj: mergeFieldsOrgInfo = {
        applicationNumber: '',
        organizationName: '',
        organizationId: '',
        address: null,
    };
    levelInfo: levelContext = {
        id: '',
        data: {
            categoryCode: '',
            documentTypeName: '',
            orgInfo: this.orgObj,
            editedLetter: this.letterContentModel,
            templateId: '',
            templateName: '',
            nextLevelOfReviewRequiresGroupSelection: false
        }
    };

    constructor(
        private activeRoute: ActivatedRoute,
        public groupService: GroupService,
        public dialogService: DynamicDialogService,
        public textService: TextTemplatesService,
        private chiefsOrderService: ChiefsOrderService,
        private readonly loader: LoaderService,
        public router: Router,
        private subHeaderService: SubHeaderService
    ) { }

    ngOnInit() {

        this.subHeaderService.updateSubHeader(this.subHeader);


        if (this.activeRoute.snapshot.queryParams['prev']) {
            if (window.sessionStorage.getItem('levelInfo')) {
                this.levelInfo = JSON.parse(window.sessionStorage.getItem('levelInfo'));
                window.sessionStorage.removeItem('levelInfo');
            }
        }
        else {
            if (this.activeRoute.snapshot.data['coinprogress']) {
                this.levelInfo = this.activeRoute.snapshot.data['coinprogress'];
            }
        }

        this.titleText = this.levelInfo.data.templateName;

    }

    ngAfterViewInit(): void {
        this.letterContentModel.htmlHeader = this.levelInfo.data.editedLetter.htmlHeader;
        this.letterContentModel.htmlContent = this.levelInfo.data.editedLetter.htmlContent;
        this.letterContentModel.htmlFooter = this.levelInfo.data.editedLetter.htmlFooter;
        this.letterContentModel.id = this.levelInfo.data.editedLetter.id;
        this.form.controls['updatedContents'].setValue(this.letterContentModel.htmlContent);
    }
    
    ngOnDestroy() {
        this.sub.forEach(s => s.unsubscribe());
    }

    saveLetter(): void {
        this.loader.toggleLoader(true);

        this.levelInfo.data.editedLetter.htmlContent = stripFroalaWatermark(this.form.controls['updatedContents'].value);
        this.levelInfo.data.editedLetter.id = this.letterContentModel.id;

        var srv$ = this.chiefsOrderService.saveletter(this.levelInfo).pipe(finalize(() => {
            this.sub.push(srv$);
        })).subscribe(result => {
            if (result) {
                this.loader.toggleLoader(false);
                var coid = result;
                if (window.sessionStorage) {
                    window.sessionStorage.setItem('levelInfo', JSON.stringify(this.levelInfo));
                }
                this.loader.toggleLoader(false);
                this.router.navigate(['/admin/chief-orders/co-submit-chiefsorder', coid]);
            }
        }, error => {
            console.log('failed to save...' + error);
            this.loader.toggleLoader(false);
        });
    }
}
